module.exports = __webpack_public_path__ + "static/media/Gefuehlsmonster_Logo-Monster_schwarz-weiss.a6336e21.svg";